const Footer = () => {
  return (
    <footer data-testid="footer-copyright">
      Copyright &copy; Team Innov8 2023
    </footer>
  );
};

export default Footer;
